"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import './Notifications.css'
import { useAuth } from "../context/AuthContext"
// YENİ İKONLAR EKLENDİ
import {
    FiPlus,
    FiTrash2,
    FiCheck,
    FiBell,
    FiAlertTriangle,
    FiCheckSquare,
} from "react-icons/fi"

const Notifications = () => {
    const { isAdmin } = useAuth()
    const [notifications, setNotifications] = useState([])
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [formData, setFormData] = useState({
        title: "",
        message: "",
        type: "announcement",
        user_id: "",
        scheduled_at: "",
    })
    const [error, setError] = useState("")

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [notifsRes, usersRes] = await Promise.all([
                api.get("/notifications"),
                isAdmin ? api.get("/users") : Promise.resolve({ data: [] }),
            ])
            setNotifications(notifsRes.data.data || notifsRes.data)
            setUsers(usersRes.data.data || usersRes.data)
        } catch (error) {
            console.error("Veri yüklenemedi:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        try {
            await api.post("/notifications", formData)
            setShowModal(false)
            resetForm()
            loadData()
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız")
        }
    }

    const handleMarkAsRead = async (id) => {
        try {
            await api.put(`/notifications/${id}/read`)
            loadData()
        } catch (error) {
            alert("İşlem başarısız")
        }
    }

    const handleMarkAllAsRead = async () => {
        try {
            await api.put("/notifications/read-all")
            loadData()
        } catch (error) {
            alert("İşlem başarısız")
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu bildirimi silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/notifications/${id}`)
            loadData()
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const resetForm = () => {
        setFormData({
            title: "",
            message: "",
            type: "announcement",
            user_id: "",
            scheduled_at: "",
        })
        setError("")
    }

    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    // Belirli bir bildirim türü için ikonu ve metni döndüren bir yardımcı fonksiyon
    // Bu, React.createElement içinde koşullu render'ı basitleştirir
    const getNotificationTypeDetails = (type) => {
        switch (type) {
            case "announcement":
                return { icon: FiBell, label: "Duyuru", className: "type-announcement" }
            case "reminder":
                return { icon: FiAlertTriangle, label: "Hatırlatma", className: "type-reminder" }
            case "task":
                return { icon: FiCheckSquare, label: "Görev", className: "type-task" }
            default:
                return { icon: FiBell, label: type, className: "type-default" }
        }
    }

    return React.createElement(
        "div",
        { className: "notifications-page" },
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "Bildirimler"),
            React.createElement(
                "div",
                { style: { display: "flex", gap: "12px" } },
                React.createElement(
                    "button",
                    { className: "btn btn-outline", onClick: handleMarkAllAsRead },
                    React.createElement(FiCheck),
                    "Tümünü Okundu İşaretle",
                ),
                isAdmin &&
                React.createElement(
                    "button",
                    {
                        className: "btn btn-primary",
                        onClick: () => {
                            resetForm()
                            setShowModal(true)
                        },
                    },
                    React.createElement(FiPlus),
                    "Yeni Bildirim",
                ),
            ),
        ),
        notifications.length === 0
            ? React.createElement(
                "div",
                { className: "card", style: { textAlign: "center", padding: "48px" } },
                React.createElement(
                    "p",
                    { style: { color: "var(--text-secondary)", fontSize: "16px" } },
                    "Henüz bildirim bulunmuyor",
                ),
            )
            : React.createElement(
                "div",
                { className: "notifications-list" },
                notifications.map((notif) => {
                    const typeDetails = getNotificationTypeDetails(notif.type)

                    return React.createElement(
                        "div",
                        {
                            key: notif.id,
                            className: `notification-card ${notif.is_read ? "read" : "unread"} ${typeDetails.className}`,
                        },
                        // 1. İkon Alanı
                        React.createElement(
                            "div",
                            { className: "notification-icon-wrapper" },
                            React.createElement(typeDetails.icon, { className: "icon" }),
                        ),
                        // 2. İçerik Alanı
                        React.createElement(
                            "div",
                            { className: "notification-content" },
                            React.createElement(
                                "div",
                                { className: "notification-header" },
                                React.createElement("h3", null, notif.title),
                                React.createElement(
                                    "span",
                                    { className: `badge ${typeDetails.className}` },
                                    typeDetails.label,
                                ),
                            ),
                            // *** ÖNEMLİ NOT: "Kimden Geldiği" Bilgisi ***
                            // 'notif.sender_name' gibi bir alan API'den gelirse
                            // aşağıdaki 'false &&' kısmını kaldırarak aktifleştirebilirsiniz.
                            false && React.createElement(
                                "span",
                                { className: "notification-sender" },
                                "Gönderen: ",
                                // notif.sender_name // <--- Buraya 'den gelen veri
                            ),
                            React.createElement("p", null, notif.message),
                            React.createElement(
                                "span",
                                { className: "notification-date" },
                                new Date(notif.created_at).toLocaleString("tr-TR"),
                            ),
                        ),
                        // 3. Eylem Butonları Alanı
                        React.createElement(
                            "div",
                            { className: "notification-actions" },
                            !notif.is_read &&
                            React.createElement(
                                "button",
                                { className: "btn-icon", onClick: () => handleMarkAsRead(notif.id), title: "Okundu İşaretle" },
                                React.createElement(FiCheck),
                            ),
                            React.createElement(
                                "button",
                                { className: "btn-icon danger", onClick: () => handleDelete(notif.id), title: "Sil" },
                                React.createElement(FiTrash2),
                            ),
                        ),
                    )
                }),
            ),

        // Modal kısmı (değiştirilmedi)
        showModal &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, "Yeni Bildirim"),
                error && React.createElement("div", { className: "error-message" }, error),
                React.createElement(
                    "form",
                    { onSubmit: handleSubmit },
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Başlık *"),
                        React.createElement("input", {
                            type: "text",
                            value: formData.title,
                            onChange: (e) => setFormData({ ...formData, title: e.target.value }),
                            required: true,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Mesaj *"),
                        React.createElement("textarea", {
                            value: formData.message,
                            onChange: (e) => setFormData({ ...formData, message: e.target.value }),
                            required: true,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Tür"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.type,
                                    onChange: (e) => setFormData({ ...formData, type: e.target.value }),
                                },
                                React.createElement("option", { value: "announcement" }, "Duyuru"),
                                React.createElement("option", { value: "reminder" }, "Hatırlatma"),
                                React.createElement("option", { value: "task" }, "Görev"),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Alıcı"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.user_id,
                                    onChange: (e) => setFormData({ ...formData, user_id: e.target.value }),
                                },
                                React.createElement("option", { value: "" }, "Tüm Personel"),
                                users.map((user) =>
                                    React.createElement(
                                        "option",
                                        { key: user.id, value: user.id },
                                        `${user.first_name} ${user.last_name}`,
                                    ),
                                ),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Zamanlanmış Tarih"),
                        React.createElement("input", {
                            type: "datetime-local",
                            value: formData.scheduled_at,
                            onChange: (e) => setFormData({ ...formData, scheduled_at: e.target.value }),
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "modal-actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                            "İptal",
                        ),
                        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Gönder"),
                    ),
                ),
            ),
        ),
    )
}

export default Notifications